import { useTranslation } from 'react-i18next';
import { DEFAULT_LOCALE, normalizeLocale, type SupportedLocale } from './constants';

/** The active catalog locale, for the Intl formatters in `./format`. */
export function useLocale(): SupportedLocale {
  const { i18n } = useTranslation();
  return normalizeLocale(i18n.resolvedLanguage ?? i18n.language) ?? DEFAULT_LOCALE;
}
